import React from 'react';
import styled from 'styled-components';

import { HEADER_NAV_LINKS, ANCHOR_URLS } from '../constants/navigationLinks';
import Links from './Links';
import Button from './Button';

const DesktopNavStyles = styled.nav`
  display: flex;
  align-items: center;
  justify-content: end;
  padding: 0;
  width: 100%;
  font-size: var(--heading6-size);
  gap: var(--spacing-xlarge);

  ul {
    display: flex;
    align-items: center;
  }
`;

const DesktopNav: React.FC = () => {
  return (
    <DesktopNavStyles>
      <Links links={HEADER_NAV_LINKS} gap="xlarge" buttonStyles={{ colorScheme: 'scheme3' }} />
      <Button href={ANCHOR_URLS.contact} text="Contact Me" colorScheme="scheme2" />
    </DesktopNavStyles>
  );
};

export default DesktopNav;
